import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";
import { useSettings, useCategories } from "../context/StoreDataContext";

export default function Footer() {
    const { settings } = useSettings();
    const { categories } = useCategories();
    return (
        <footer className="border-t border-border-soft/60 bg-blush mt-24" data-testid="site-footer">
            <div className="px-6 md:px-12 lg:px-20 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
                <div className="md:col-span-2">
                    <div className="flex items-baseline gap-2">
                        <span className="font-serif italic text-3xl text-charcoal">Luz de</span>
                        <span className="font-serif text-3xl text-rose">Angely</span>
                    </div>
                    <p className="mt-4 max-w-md text-sm text-taupe leading-relaxed">
                        {settings?.brand_tagline || "Bisutería artesanal hecha con amor."}
                    </p>
                </div>
                <div>
                    <p className="overline mb-4">Tienda</p>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <Link to="/catalogo" className="hover:text-rose">Catálogo</Link>
                        </li>
                        {categories.map((c) => (
                            <li key={c.id}>
                                <Link to={`/catalogo?cat=${c.slug}`} className="hover:text-rose">
                                    {c.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <p className="overline mb-4">Contacto</p>
                    <ul className="space-y-3 text-sm">
                        {settings?.contact_email && (
                            <li className="flex items-center gap-2 text-taupe">
                                <Mail strokeWidth={1.5} className="w-4 h-4" /> {settings.contact_email}
                            </li>
                        )}
                        {settings?.instagram && (
                            <li className="flex items-center gap-2 text-taupe">
                                <Instagram strokeWidth={1.5} className="w-4 h-4" /> @{settings.instagram.replace(/^@/, "")}
                            </li>
                        )}
                        {(settings?.address || settings?.city) && (
                            <li className="flex items-start gap-2 text-taupe">
                                <MapPin strokeWidth={1.5} className="w-4 h-4 mt-0.5 shrink-0" />
                                <span>
                                    {[settings.address, settings.city].filter(Boolean).join(", ")}
                                </span>
                            </li>
                        )}
                        <li>
                            <Link to="/admin/login" className="text-xs text-taupe/60 hover:text-rose" data-testid="admin-login-link">
                                Admin
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-border-soft/60 px-6 md:px-12 lg:px-20 py-6 text-xs text-taupe flex flex-col md:flex-row justify-between gap-2">
                <span>© {new Date().getFullYear()} Luz de Angely. Todos los derechos reservados.</span>
                <span className="italic font-serif text-base">Hecho con corazón.</span>
            </div>
        </footer>
    );
}
